import React from 'react';

import { SignupByInviteFormStepId } from 'src/constants/auth';
import { useAuthSignup } from 'src/hooks/auth';
import { SxProp } from 'src/types/mui';

import { AuthPaperBox } from '../AuthPaperBox';

import {
  ConsumerAttestationsForm,
  ConsumerReviewDataForm,
  ConsumerVerificationPreferenceForm,
  CvStaffAttestationsForm,
  EmployeeAttestationsForm,
  EmployeeSignupMethodForm,
  EmployeeVerificationPreferenceForm,
  EmployerBasicInfoForm,
  InitialStepForm,
  NoticeToFurnishersForm,
  PEOBasicInfoForm,
  PEOPayrollProviderBasicInfoForm,
  PeoAttestationsForm,
  PeoPayrollProviderAttestationsForm,
  VerifierAccountTypeForm,
  VerifierAttestationsForm,
  VerifierBasicInfoForm,
  YourCompanyExistInfoBlock,
} from './components';

export const SignupByInvitePageForm: React.FC = () => {
  const { formStepperState } = useAuthSignup();

  const boxStyles: SxProp | undefined = React.useMemo(() => {
    if (formStepperState.currentStepId === SignupByInviteFormStepId.consumerReviewData) {
      return consumerReviewDataContainerStyles;
    }
    if (formStepperState.currentStepId === SignupByInviteFormStepId.noticeToFurnishers) {
      return noticeToFurnishersStep;
    }
    return undefined;
  }, [formStepperState.currentStepId]);

  const renderForm = () => {
    switch (formStepperState.currentStepId) {
      case SignupByInviteFormStepId.initial:
        return <InitialStepForm />;
      case SignupByInviteFormStepId.employerBasicInfo:
        return <EmployerBasicInfoForm />;
      case SignupByInviteFormStepId.employeeVerificationPreference:
        return <EmployeeVerificationPreferenceForm />;
      case SignupByInviteFormStepId.employeeSignupMethod:
        return <EmployeeSignupMethodForm />;
      case SignupByInviteFormStepId.employeeAttestations:
        return <EmployeeAttestationsForm />;
      case SignupByInviteFormStepId.choseVerifierAccountType:
        return <VerifierAccountTypeForm />;
      case SignupByInviteFormStepId.verifierBasicInfo:
        return <VerifierBasicInfoForm />;
      case SignupByInviteFormStepId.consumerAttestations:
        return <ConsumerAttestationsForm />;
      case SignupByInviteFormStepId.peoAttestations:
        return <PeoAttestationsForm />;
      case SignupByInviteFormStepId.peoPayrollProviderAttestations:
        return <PeoPayrollProviderAttestationsForm />;
      case SignupByInviteFormStepId.cvStaffAttestations:
        return <CvStaffAttestationsForm />;
      case SignupByInviteFormStepId.verifierAttestations:
        return <VerifierAttestationsForm />;
      case SignupByInviteFormStepId.consumerReviewData:
        return <ConsumerReviewDataForm />;
      case SignupByInviteFormStepId.peoBasicInfo:
        return <PEOBasicInfoForm />;
      case SignupByInviteFormStepId.peoPayrollProviderBasicInfo:
        return <PEOPayrollProviderBasicInfoForm />;
      case SignupByInviteFormStepId.consumerVerificationPreference:
        return <ConsumerVerificationPreferenceForm />;
      case SignupByInviteFormStepId.noticeToFurnishers:
        return <NoticeToFurnishersForm />;
      case SignupByInviteFormStepId.yourCompanyExistInfoBlock:
        return <YourCompanyExistInfoBlock />;
      default:
        return null;
    }
  };

  return <AuthPaperBox sx={boxStyles}>{renderForm()}</AuthPaperBox>;
};

const consumerReviewDataContainerStyles: SxProp = {
  maxWidth: 'none',
  minWidth: 540,
};

const noticeToFurnishersStep: SxProp = {
  maxWidth: 827,
};
